import Utility from './common/UtilityFunctions.js';

window.language = window.siteLanguage || 'da';
window.dateFormat = window.dateFormat || 'LL'; // 5. januar 2018
window.brand = Utility.getBrand();
window.Utility = Utility;

const constant = Utility.constants();

window.CONSTANT = constant;
